import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kaghuchrc: FaireProductEntity = {
  token: "p_8kaghuchrc",
  type: "product",
  name: "Hen Candle — Hand-Poured Decorative Object",
  brandToken: "b_7srg6ubmfn",
  brandName: "Cook's Bay Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/71e1ddd5c15cfa864e36c7795dd610b28b65f707634e704f672157c6da8590c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03a2cc568aadb148eaa304ffb46cc39ef9401435d831fda41ca90e91f2522ecd.jpeg",
    "https://cdn.faire.com/fastly/476149e0fd90432e267fc4346a75de92f97dbdebf8cd9785f7c8e46e997ef5c0.jpeg",
    "https://cdn.faire.com/fastly/ad122fca0e488590e1b81a1f0c77e7f8524965bfc8208cca137b7184f649696a.jpeg",
    "https://cdn.faire.com/fastly/b8c5d4dc24c6d9b00b96b67d09416e7ae49f33466d079a31be604e83e1dae952.jpeg",
    "https://cdn.faire.com/fastly/35e540ad92ab5b19e58dc584d8ea0defa97888969e09a1b1e3231d9b1b729e94.jpeg",
  ],
  priceDollars: 12,
  description:
    "A hand-poured, hand-dyed hen — no two alike, from soft cream to marbled cocoa to smoky plum. Burns from the centre with a soft glow while the shape holds, so it doubles as a keepsake. Request colours, or leave it up to nature. Unscented, by design.\n\nWholesale $12 · MSRP $24\nSold as: single · Case of 1 \nSize: approx. 3″ H\nMade with: natural soy & beeswax, cotton wick· unscented\nBurn time: approx. 8–10 hrs\nColourways: assorted / customizable\nLead time: 2–3 weeks† · Ships approx. 0.3 lb†",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:13.243Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
